import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ChevronLeft, MinusIcon, PlusIcon, X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Image from "../../components/Image";
import { Button, Skeleton } from "@mui/material";
import "../shop_cart/cart.css";
import { api } from "../../api/api";
import { Coupan, getPromoCodeUrl, shop_cart, Wallet_url } from "../../api/urls";
import Empty from "../../Assests/CartIcon.svg";
import { Typography, Box } from "@mui/material";
import { b2bcredit } from "../../api/urls";
// import { ChevronRightCircle } from "lucide-react";
import { ChevronRight } from "lucide-react";
import { toast } from "react-toastify";
// import couponimg from "../../Assests/coupons.png";
import {
  setCartItems,
  setCredit,
  setWallet,
  setPoints,
} from "../../Redux/CartSlice";
import { point_url } from "../../api/urls";
// import { setCreditData } from "../../Redux/B2b";

import { setMinCapPoints, setPointBalance } from "../../Redux/Point";
import OrderSummarySection from "../../components/OrderSummary";
import useFetch from "../../hooks/useFetch";
import { setWalletBalance } from "../../Redux/Wallet";
import { setCreditData } from "../../Redux/B2b";
import { useIsMobile } from "../../hooks/useIsMobile";
// import { color } from "framer-motion";
// import emptyimg from "../../Assests/emptyimg.png";

const Shopcart = () => {
  const dispatch = useDispatch();
  const { data: walletData } = useFetch(Wallet_url);
  const { data: pointsData } = useFetch(point_url);
  const { data: creditsData } = useFetch(b2bcredit);

  useEffect(() => {
    if (walletData && pointsData && creditsData) {
      dispatch(setPointBalance(pointsData?.wallet_coin));
      dispatch(setMinCapPoints(Number(pointsData?.min_pts_cap_pts)));
      dispatch(setWalletBalance(walletData?.wallet_money));
      dispatch(setCreditData(creditsData));
    }
  }, [dispatch, walletData, pointsData, creditsData]);
  // const balance = useSelector((state) => state.wallet.balance);
  const { points: Point, minCapPoints: minCap } = useSelector(
    (state) => state.point,
  );

  const productcart = useSelector((state) => state.cart.items);
  const [quantities, setQuantities] = useState({});
  const [couponIndex, setCouponIndex] = useState(0);
  // const VISIBLE_COUNT = 3;
  const isMobile = useIsMobile();
  const couponsPerPage = isMobile ? 1 : 3;
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [promoCodeInput, setPromoCodeInput] = useState("");
  const [appliedCoupons, setAppliedCoupons] = useState([]);
  const [totals, setTotals] = useState({
    total: 0,
    discount: 0,
    sellingPrice: 0,
    finalTotal: 0,
    couponDiscount: 0,
    deliveryCharges: 0,
    packingCharges: 0,
    discountPercent: 0,
    pointsUsed: 0,
    pointsUsedInRupees: 0,
  });

  const [walletUsed, setWalletUsed] = useState(0);
  const [amountToPay, setAmountToPay] = useState(totals.finalTotal);
  // const [consumedBy, setConsumedBy] = useState("");
  const [isapplied, setisApplied] = useState(false);
  // const [lastToggledOption, setLastToggledOption] = useState(null);
  const handleNext = () => {
    if (couponIndex + couponsPerPage < appliedCoupons.length) {
      setCouponIndex(couponIndex + 1);
    }
  };

  // const credit = useSelector((state) => state.credit);
  const credit = useSelector((state) => state.credit);

  const [creditUsedAmount, setCreditUsedAmount] = useState(0);
  const balance = useSelector((state) => state.wallet.balance);

  const [paymentOptions, setPaymentOptions] = useState({
    wallet: false,
    points: false,
    credit: false,
  });
  useEffect(() => {
    setCouponIndex(0);
  }, [appliedCoupons.length]);

  const handleIncrement = async (itemId) => {
    const newQty = (quantities[itemId] || 1) + 1;
    setQuantities((prev) => ({ ...prev, [itemId]: newQty }));

    await api.patch(`/in/tagon_products/cart/${itemId}/`, {
      quantity: newQty,
    });
  };

  const handleDecrement = async (itemId) => {
    const currentQty = quantities[itemId] || 1;
    if (currentQty > 1) {
      const newQty = currentQty > 1 ? currentQty - 1 : 1;
      setQuantities((prev) => ({ ...prev, [itemId]: newQty }));

      try {
        await api.patch(`/in/tagon_products/cart/${itemId}/`, {
          quantity: newQty,
        });
      } catch (error) {
        // Show backend message if available
        const errorMessage =
          error.response?.data?.data || // <-- use this path
          "Something went wrong. Please try again.";

        toast.error(errorMessage);

        // Reset quantity to previous valid value
        setQuantities((prev) => ({ ...prev, [itemId]: currentQty }));
      }
    }
  };

  const navigate = useNavigate();

  const { data: cartData, refetch, loading } = useFetch(shop_cart);

  useEffect(() => {
    if (cartData) {
      dispatch(setCartItems(cartData));

      const initialQuantities = {};
      cartData.forEach((item) => {
        initialQuantities[item.id] = item.quantity || 1;
      });
      setQuantities(initialQuantities);
    }
  }, [cartData, dispatch]);

  const handleRemove = async (id) => {
    try {
      await api.delete(`/in/tagon_products/cart/${id}/`);
      refetch();
      // fetchCart();
    } catch (error) {
      console.error(
        "Error removing item:",
        error.response?.data || error.message,
      );
    }
  };
  const handlePrev = () => {
    if (couponIndex > 0) {
      setCouponIndex(couponIndex - 1);
    }
  };
  const calculateTotal = useCallback(() => {
    let totalMRP = 0;
    let totalDiscount = 0;
    let totalSellingPrice = 0;
    let deliveryCharges = 0;
    let packingCharges = 0;

    productcart &&
      productcart.forEach((item) => {
        const qty = quantities[item.id] || 1;
        const country = item.country_details || {};

        const mrp = parseFloat(country.product_price) || 0;
        const discount = parseFloat(country.you_save) || 0;
        // const selling = parseFloat(country.sell_price) || 0;
        const discount_price = parseFloat(country.discount_price) || 0;

        totalMRP += mrp * qty;
        totalDiscount += discount * qty;
        totalSellingPrice += discount_price * qty;

        deliveryCharges += parseFloat(country.shipping_charges || 0) * qty;
        packingCharges +=
          parseFloat(country.packing_and_forwarding_charges || 0) * qty;
      });

    const couponDiscount = appliedCoupons.reduce(
      (sum, coupon) => sum + (coupon?.value || 0),
      0,
    );

    const discountedTotal =
      appliedCoupons.length > 0 &&
      appliedCoupons[0]?.discountedPrice !== undefined
        ? appliedCoupons[0].discountedPrice
        : totalSellingPrice;

    const finalTotal =
      parseFloat(discountedTotal) + deliveryCharges + packingCharges;

    const discountPercent =
      (productcart && productcart[0]?.country_details?.discout_percent) || 0;

    const pointConversionRate = 100;
    const maxPointsPercent = 2;
    const availablePoints = Point;

    const maxPointsInRupees = parseFloat(
      (totalSellingPrice * maxPointsPercent) / 100,
    );
    const maxPointsAllowed = Math.floor(
      maxPointsInRupees * pointConversionRate,
    ); // e.g., ₹5.14 * 100 = 514 points

    const pointsUsed =
      paymentOptions.points && availablePoints >= minCap
        ? Math.min(availablePoints, maxPointsAllowed)
        : 0;

    const pointsUsedInRupees = pointsUsed / pointConversionRate;

    return {
      total: parseFloat(totalMRP.toFixed(2)),
      discount: parseFloat(totalDiscount.toFixed(2)),
      sellingPrice: parseFloat(totalSellingPrice.toFixed(2)),
      finalTotal: isNaN(finalTotal) ? 0 : parseFloat(finalTotal.toFixed(2)),
      couponDiscount: parseFloat(couponDiscount.toFixed(2)),
      deliveryCharges: parseFloat(deliveryCharges.toFixed(2)),
      packingCharges: parseFloat(packingCharges.toFixed(2)),
      discountPercent,
      pointsUsed,
      pointsUsedInRupees: parseFloat(pointsUsedInRupees.toFixed(2)),
    };
  }, [productcart, quantities, appliedCoupons, Point, minCap, paymentOptions]);

  useEffect(() => {
    const totals = calculateTotal();
    setTotals(totals);
  }, [calculateTotal]);

  const disableCheckbox = amountToPay === 0;

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const response = await api.get(Coupan);
        setAppliedCoupons(response.data);
      } catch (error) {
        console.error("GET Error:", error?.response?.data || error.message);
      }
    };

    fetchCoupons();
  }, []);

  const handleCouponClick = (coupon) => {
    // setPromoCodeInput(coupon.printable_name);
    setSelectedCoupon(coupon);
  };

  // useEffect(() => {
  //   if (amountToPay === 0 && lastToggledOption) {
  //     setConsumedBy(lastToggledOption);
  //   }
  // }, [amountToPay, lastToggledOption]);
  useEffect(() => {
    let payable = totals.finalTotal;

    // 1️⃣ Coupon
    if (selectedCoupon && isapplied) {
      payable -= selectedCoupon.value;
    }
    payable = Math.max(0, payable);

    // 2️⃣ Points
    let pointsUsedRupees = 0;
    if (paymentOptions.points && Point >= minCap) {
      pointsUsedRupees = Math.min(totals.pointsUsedInRupees, payable);
      payable -= pointsUsedRupees;
    }

    // 3️⃣ Wallet
    let walletUsedNow = 0;
    if (paymentOptions.wallet) {
      walletUsedNow = Math.min(balance, payable);
      payable -= walletUsedNow;
    }
    setWalletUsed(walletUsedNow);

    // 4️⃣ Credit
    let creditUsedNow = 0;
    if (paymentOptions.credit) {
      creditUsedNow = Math.min(credit.data || 0, payable);
      payable -= creditUsedNow;
    }
    setCreditUsedAmount(creditUsedNow);

    setAmountToPay(Number(payable.toFixed(2)));
  }, [
    totals.finalTotal,
    totals.pointsUsedInRupees,
    selectedCoupon,
    isapplied,
    paymentOptions,
    Point,
    minCap,
    balance,
    credit.data,
  ]);
  if (!loading && productcart && productcart?.length === 0) {
    return (
      <Box
        sx={{
          textAlign: "center",
          mt: 15,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          component="img"
          src={Empty}
          alt="Empty Cart"
          sx={{ width: 250, mb: 3 }}
        />
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
          Your Cart is Empty!
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate("/products")}
          sx={{ backgroundColor: "#000000", mb: 10 }}
        >
          Go to Shopping
        </Button>
      </Box>
    );
  }

  return (
    <div className="shopcart-wrapper">
      <div className="shopcart-container">
        <div className="items-section">
          <CartHeader />
          {loading &&
            Array.from({ length: productcart?.length || 1 }).map((_, index) => (
              <CartSkeleton key={index} />
            ))}
          {!loading &&
            productcart &&
            productcart?.length > 0 &&
            productcart.map((item) => {
              const isStockLimitReached =
                quantities[item.id] >= item.country_details.stock;
              return (
                <div key={item.id} className="cart-item-main">
                  <div className="cart-item">
                    <button
                      className="remove-button"
                      onClick={() => handleRemove(item.id)}
                      aria-label={`Remove ${item.product_title} from cart`}
                    >
                      <X size={19} />

                      {/* <CircleX size={22} /> */}
                    </button>
                    <div
                      className="item-image-container cursor-pointer"
                      onClick={() => {
                        navigate(`/products/${item.product}`);
                      }}
                    >
                      <Image
                        src={item.product_image}
                        alt={item.product_title}
                        className="item-image"
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="item-content">
                      <div className="item-header">
                        <h3 className="item-title">{item.product_title}</h3>
                      </div>

                      <div className="item-details-grid">
                        <div className="detail-row">
                          <span className="detail-label">Order ID:</span>
                          <span className="detail-value">{item.id}</span>
                        </div>

                        {item.size && (
                          <div className="detail-row">
                            <span className="detail-label">Size:</span>
                            <span className="detail-value">{item.size}</span>
                          </div>
                        )}

                        {item.color && (
                          <div className="detail-row">
                            <span className="detail-label">Colour:</span>
                            <span className="detail-value">{item.color}</span>
                          </div>
                        )}

                        <div className="detail-row">
                          <span className="detail-label">Price:</span>

                          <span className="detail-value">
                            ₹{item.country_details?.sell_price?.toFixed(2)}
                          </span>
                        </div>
                      </div>

                      {/* Quantity */}
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 2 }}
                      >
                        <button
                          className="border p-2 rounded-md h-10 w-10 flex items-center justify-center disabled:bg-gray-200 disabled:text-black bg-black text-white"
                          onClick={() => handleDecrement(item.id)}
                          disabled={quantities[item.id] === 1}
                        >
                          <MinusIcon size={18} />
                        </button>
                        <div className="border p-2 rounded-md h-10 w-10 flex items-center justify-center">
                          {quantities[item.id] || 1}
                        </div>
                        {/* <Box
                          sx={{
                            py: 1,
                            px: 2,
                            border: "1px solid",
                            borderRadius: "6px",
                          }}
                        >
                          {quantities[item.id] || "1"}
                        </Box> */}
                        <button
                          className={`border p-2 rounded-md h-10 w-10 flex items-center justify-center disabled:bg-gray-200 disabled:text-black bg-black text-white`}
                          onClick={() => handleIncrement(item.id)}
                          disabled={isStockLimitReached}
                        >
                          <PlusIcon size={18} />
                        </button>
                      </Box>
                    </div>
                  </div>
                  {appliedCoupons?.length > 0 && (
                    <div className="applied-coupons items-center mt-5">
                      {
                        appliedCoupons?.length > couponsPerPage && (
                          <ChevronLeft
                            onClick={handlePrev}
                            className="cursor-pointer hover:opacity-50"
                          />
                        )
                        // </button>
                      }

                      <div className="flex md:flex-row flex-col gap-2 flex-1">
                        {appliedCoupons
                          .slice(couponIndex, couponIndex + couponsPerPage)
                          .map((coupon) => (
                            <div
                              key={coupon.code}
                              className="flex-1 flex border p-2 w-full rounded-lg gap-2 cursor-pointer hover:bg-gray-100"
                              onClick={() => handleCouponClick(coupon)}
                            >
                              {" "}
                              <Image
                                src={coupon?.coupon_image}
                                alt="cpn"
                                fill
                                style={{
                                  height: "40px",
                                  width: "40px",
                                  borderRadius: "50%",
                                  border: "1px solid #ACACAC",
                                }}
                              />
                              <div className="coupon-info">
                                <div style={{ textAlign: "start" }}>
                                  <div className="coupon-code">
                                    {coupon.promocode}
                                  </div>
                                  <div className="coupon-desc">
                                    Get {coupon.discount_upto}% off on minimum
                                    purchase of {coupon.currency_symbol}
                                    {coupon.min_txn}/-
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>

                      {appliedCoupons?.length > couponsPerPage && (
                        <ChevronRight
                          onClick={handleNext}
                          className="cursor-pointer hover:opacity-50"
                        />
                      )}
                    </div>
                  )}
                </div>
              );
            })}
        </div>
        <div className="md:mt-12">
          <OrderSummarySection
            paymentOptions={paymentOptions}
            // setLastToggledOption={setLastToggledOption}
            setWalletUsed={setWalletUsed}
            selectedCoupon={selectedCoupon}
            setSelectedCoupon={setSelectedCoupon}
            setPaymentOptions={setPaymentOptions}
            totals={totals}
            setAmountToPay={setAmountToPay}
            // Point={Point}
            amountToPay={amountToPay}
            // setConsumedBy={setConsumedBy}
            promoCodeInput={promoCodeInput}
            setPromoCodeInput={setPromoCodeInput}
            // balance={balance}
            disableCheckbox={disableCheckbox}
            // consumedBy={consumedBy}
            walletUsed={walletUsed}
            minCap={minCap}
            creditUsedAmount={creditUsedAmount}
            // credit={credit}
            setCartItems={setCartItems}
            setCredit={setCredit}
            productcart={productcart}
            setWallet={setWallet}
            setPoints={setPoints}
            setAppliedCoupons={setAppliedCoupons}
            appliedCoupons={appliedCoupons}
            calculateTotal={calculateTotal}
            getPromoCodeUrl={getPromoCodeUrl}
            setisApplied={setisApplied}
            isapplied={isapplied}
            // lastToggledOption={lastToggledOption}
          />
        </div>
      </div>
    </div>
  );
};

export default Shopcart;
const CartSkeleton = () => {
  return (
    <div
      className="cart-item-main"
      style={{ padding: "15px", minHeight: "200px" }}
    >
      <div className="cart-item" style={{ display: "flex", gap: "15px" }}>
        {/* Product Image */}
        <Skeleton variant="rectangular" width={90} height={90} />

        {/* Content */}
        <div style={{ flex: 1 }}>
          <Skeleton variant="text" width="20%" height={28} />
          <Skeleton variant="text" width="30%" height={22} />
          <Skeleton variant="text" width="50%" height={22} />
          <Skeleton variant="text" width="20%" height={22} />
          <Skeleton variant="text" width="40%" height={22} />
          <Skeleton variant="text" width="60%" height={22} />
          <Skeleton variant="text" width="30%" height={22} />
          <Skeleton variant="text" width="60%" height={22} />
          <Skeleton variant="text" width="50%" height={22} />

          <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
            <Skeleton variant="rectangular" width={100} height={35} />
          </div>
        </div>
        {/* Remove Button */}
        <Skeleton variant="circular" width={25} height={25} />
      </div>
    </div>
  );
};

const CartHeader = () => {
  const navigate = useNavigate();
  return (
    <div className="cart-header">
      <div className="back-button" onClick={() => navigate(-1)}>
        <ChevronLeft size={20} />
        <span>Back to Store</span>
      </div>
      <h2 className="cart-title">Shopping Cart</h2>
    </div>
  );
};
